module.exports = __webpack_public_path__ + "img/stalk-medium.d0c5dbaa.svg";